<template>
  <div class="skin-profile pa-4">
    <div class="skin-profile__main">
      <SkinProfileRow
        v-for="(skinProfile, index) in skinProfiles"
        :key="index"
        class="skin-profile__row"
        :skin-profile="skinProfile"
        @delete="deleteSkinProfile"
      />
    </div>

    <FloatingButton data-cy="add-button" @click="showAddForm">
      <fa icon="plus" />
    </FloatingButton>

    <SkinProfileForm
      v-if="shouldShowAddForm"
      @save="onSubmitSkinProfileForm"
      @close="closeAddForm"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import SkinProfileRow from "@/components/skin-profile/SkinProfileRow.vue";
import SkinProfileForm from "@/components/skin-profile/SkinProfileForm.vue";
import FloatingButton from "@/components/FloatingButton.vue";

import useSkinProfiles from "@/composition/skin-profile/skin-profile";
import useUpload from "@/composition/skin-profile/upload";
import {
  SkinProfileToAdd,
  SkinProfileTextFields
} from "@/controller/skin-profile";
import { FirebaseImage } from "@/controller/uploader";

export default defineComponent({
  name: "SkinProfile",

  components: {
    SkinProfileRow,
    SkinProfileForm,
    FloatingButton
  },

  setup() {
    const {
      skinProfiles,
      deleteSkinProfile,
      addSkinProfile
    } = useSkinProfiles();

    const { uploadSkinProfileImage } = useUpload();

    const shouldShowAddForm = ref(false);
    const showAddForm = () => (shouldShowAddForm.value = true);
    const closeAddForm = () => (shouldShowAddForm.value = false);

    async function onSubmitSkinProfileForm(
      skinProfileTextFields: SkinProfileTextFields,
      image: File
    ) {
      const uploadedImage: FirebaseImage = await uploadSkinProfileImage(image);

      const skinProfileToAdd: SkinProfileToAdd = {
        ...skinProfileTextFields,
        ...uploadedImage
      };

      await addSkinProfile(skinProfileToAdd);
      closeAddForm();
    }

    return {
      skinProfiles,
      deleteSkinProfile,
      onSubmitSkinProfileForm,
      shouldShowAddForm,
      showAddForm,
      closeAddForm
    };
  }
});
</script>

<style lang="scss" scoped>
.skin-profile {
  overflow: auto;
  height: calc(100vh - #{$footerHeight} - #{$m4});
}

.skin-profile__main {
  display: flex;
  flex-direction: column-reverse;
}

.skin-profile__row {
  &:not(:last-child) {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 3px dotted black;
  }
}
</style>
